/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import i18n from '@flatsy/utils/translations'
import { FORM_ERROR } from 'final-form'
import { FlatsyApiError } from '@flatsy/types/Utils'
import {
  validatePhoneNumberFrenchOrE164,
  validateEmail as validateEmailUtils,
} from '../../Validators'

/**
 * @name getErrorText
 * @description render base or custom error text
 * @param {string} defaultTxt
 * @param {*} custom
 * @param {string} key
 * @return {*}  {string}
 */
export const getErrorText = (defaultTxt: string, custom: any, key: string): string => {
  if (custom && custom[key] && typeof custom[key] === 'string') {
    return custom[key]
  }

  return defaultTxt
}

/**
 * @name getLastNameError
 * @description render last name error
 * @param lastName string | null | undefined
 * @param customText Object? {empty: string}
 * @return {*}  string | undefined | boolean | null
 */

export const getLastNameError = ({
  lastName,
  customText,
}: {
  lastName: string | null | undefined
  customText?: { empty?: string }
}): string | undefined | boolean | null => {
  return (
    lastName !== null && !lastName && getErrorText('le nom ne peut être vide', customText, 'empty')
  )
}

/**
 * @name getFirstNameError
 * @description render first name error
 * @param firstName string | null | undefined
 * @param customText Object? {empty: string}
 * @return {*}  string | undefined | boolean | null
 */

export const getFirstNameError = ({
  firstName,
  customText,
}: {
  firstName: string | null | undefined
  customText?: { empty?: string }
}): string | undefined | boolean | null => {
  return (
    firstName !== null &&
    !firstName &&
    getErrorText('Le prénom ne peut être vide', customText, 'empty')
  )
}

/**
 * @name getPhoneError
 * @description render phone error
 * @param phoneNumber string | null | undefined
 * @param customText Object? {empty: string, format: string}
 * @return {*}  string | undefined | boolean | null
 */

export const getPhoneError = ({
  phoneNumber,
  customText,
}: {
  phoneNumber: string | null | undefined
  customText?: { empty?: string; format?: string }
}): string | undefined | boolean | null => {
  return (
    phoneNumber !== null &&
    ((!phoneNumber && getErrorText('Le téléphone ne peut être vide', customText, 'empty')) ||
      (!validatePhoneNumberFrenchOrE164(phoneNumber) &&
        getErrorText("Le numéro de téléphone saisi n'est pas au bon format", customText, 'format')))
  )
}

/**
 * @name getEmailError
 * @description render email error
 * @param email string | null | undefined
 * @param customText Object? {empty: string, format: string}
 * @return {*}  string | undefined | boolean | null
 */

export const getEmailError = ({
  email,
  customText,
}: {
  email: string | null | undefined
  customText?: { empty?: string; format?: string }
}): string | undefined | boolean | null => {
  return (
    email !== null &&
    ((!email && getErrorText("L'email ne peut être vide", customText, 'empty')) ||
      (!validateEmailUtils(email) &&
        getErrorText("L'email n'est pas valide.", customText, 'format')))
  )
}

/**
 * @name createFieldError
 * @description create an objet with translated field error
 * @param fields
 * @returns object of field
 */
const createFieldError = (fields: any): any => {
  const fieldsObject: { [key: string]: string } = {}
  if (fields && typeof fields === 'object') {
    const keys = Object.keys(fields)

    keys.forEach((element) => {
      if (element !== 'non_field_errors') {
        let string = ''
        if (fields[element]) {
          if (Array.isArray(fields[element])) {
            fields[element].forEach((singleEl: string) => {
              if (string !== '') {
                string += ', '
              }
              string += i18n.t(`error:${singleEl}`)
            })
          } else if (typeof fields[element] === 'object') {
            Object.keys(fields[element]).forEach((singleObjEl: string) => {
              if (fields[element][singleObjEl] && Array.isArray(fields[element][singleObjEl])) {
                fields[element][singleObjEl].forEach((singleEl: string) => {
                  if (string !== '') {
                    string += ', '
                  }
                  string += i18n.t(`error:${singleEl}`)
                })
              }
            })
          }
        } else {
          console.error('Bad API error format')
        }

        fieldsObject[element] = string
      }
    })
  }

  return fieldsObject
}

/**
 * @name createGlobalErrors
 * @description if non_field_errors add translate to the string
 * var else  add translate of error object to the string
 * @param fields
 * @param error
 * @returns error string
 */
export const createGlobalErrors = (fields: any, error: any): string => {
  let string = ''

  if (fields && typeof fields === 'object' && fields.non_field_errors) {
    fields.non_field_errors.forEach((singleEl: string) => {
      if (string !== '') {
        string += ', '
      }
      if (i18n && i18n.t) {
        string += i18n.t(`error:${singleEl}`)
      }
    })
  } else if (error) {
    error.forEach((singleEl: string) => {
      if (string !== '') {
        string += ', '
      }
      if (i18n && i18n.t) {
        string += i18n.t(`error:${singleEl}`)
      }
    })
  }

  return string
}

/**
 * @name flatsyErrorToFinalForm
 * @description format api error
 * @param err : FlatsyApiError
 * @returns object<string>
 */
export const flatsyErrorToFinalForm = (err: FlatsyApiError): { [FORM_ERROR]: string } => {
  const object = {
    [FORM_ERROR]: createGlobalErrors(err.validation_error, err.errors),
    ...createFieldError(err.validation_error),
  }

  return object
}
